import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

/**
 * Fields type definition for content type 'TypeNavigationCard'
 * @name TypeNavigationCardFields
 * @type {TypeNavigationCardFields}
 * @memberof TypeNavigationCard
 */
export interface TypeNavigationCardFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized false
     */
    header: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'description' (Description)
     * @name Description
     * @localized false
     */
    description?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'url' (URL)
     * @name URL
     * @localized false
     */
    url: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'icon' (Icon)
     * @name Icon
     * @localized false
     */
    icon?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'image' (Image)
     * @name Image
     * @localized false
     */
    image?: EntryFieldTypes.AssetLink;
    /**
     * Field type definition for field 'label' (Label)
     * @name Label
     * @localized false
     */
    label?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'hasGreenSeparator' (Has green separator)
     * @name Has green separator
     * @localized false
     */
    hasGreenSeparator?: EntryFieldTypes.Boolean;
    /**
     * Field type definition for field 'openInNewTab' (Open in new tab)
     * @name Open in new tab
     * @localized false
     */
    openInNewTab?: EntryFieldTypes.Boolean;
}

/**
 * Entry skeleton type definition for content type 'navigationCard' (Navigation Card)
 * @name TypeNavigationCardSkeleton
 * @type {TypeNavigationCardSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-26T19:52:53.052Z
 * @version 13
 */
export type TypeNavigationCardSkeleton = EntrySkeletonType<TypeNavigationCardFields, "navigationCard">;
/**
 * Entry type definition for content type 'navigationCard' (Navigation Card)
 * @name TypeNavigationCard
 * @type {TypeNavigationCard}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-26T19:52:53.052Z
 * @version 13
 */
export type TypeNavigationCard<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeNavigationCardSkeleton, Modifiers, Locales>;

export function isTypeNavigationCard<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeNavigationCard<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'navigationCard'
}
